import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { Trophy, ArrowRight, Clock } from 'lucide-react';
import { motion } from 'framer-motion';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          return {
            hours: 0,
            minutes: 0,
            seconds: 0
          };
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section className="relative py-12 px-4 overflow-hidden" data-id="element-195">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 50% 30%, rgba(152,224,186,0.12) 0%, rgba(152,224,186,0.04) 50%, transparent 80%)'
    }} data-id="element-196" />

      <div className="relative max-w-5xl mx-auto" data-id="element-197">
        {/* Urgency Counter */}
        <FadeIn className="text-center mb-6" data-id="element-198">
          <div className="inline-flex items-center gap-3 bg-red-500/10 border border-red-500/30 rounded-full px-6 py-3 mb-4" data-id="element-199">
            <Clock size={18} className="text-red-400" data-id="element-200" />
            <span className="text-red-400 font-bold text-sm uppercase tracking-wide" data-id="element-201">
              Oferta termina en
            </span>
            <div className="flex items-center gap-1 font-mono" data-id="element-202">
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-203">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-red-400 font-bold" data-id="element-204">:</span>
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-205">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-red-400 font-bold" data-id="element-206">:</span>
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-207">
                {pad(timeLeft.seconds)}
              </span>
            </div>
          </div>
        </FadeIn>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-8 mt-8" data-id="element-208">
          {/* Card 1: Megapack */}
          <FadeIn delay={0.1} data-id="element-209">
            <div className="relative bg-surface border border-mint/15 rounded-3xl p-8 flex flex-col h-full" data-id="element-210">
              <div className="mb-4" data-id="element-211">
                <h3 className="text-white text-xl font-[900] font-['Open_Sans',_sans-serif] uppercase mb-2" data-id="element-212">
                  🥕 Megapack Nutripro Listo
                </h3>
                <p className="text-white/50 text-sm font-medium" data-id="element-213">
                  6 Tomos + 6 Bonos
                </p>
              </div>

              <div className="mb-6 flex-1" data-id="element-214">
                <p className="text-white/40 line-through text-base mb-1" data-id="element-215">
                  Antes: $34.990 ARS
                </p>
                <p className="text-4xl md:text-5xl font-[900] text-white font-['Open_Sans',_sans-serif]" data-id="element-216">
                  $19.990
                  <span className="text-base text-white/40 font-normal ml-2" data-id="element-217">
                    ARS
                  </span>
                </p>
              </div>

              <motion.a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNAwTkYc0jPVzOcWmb07wSg/es-ar?_r=AQABOh3_y5o0n906Mqws4ivAq5RkQJOK5cqOLDDedCXRGTQ&cart_link_id=1TztK5e8&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-gradient-to-r from-mint to-emerald-400 hover:from-mint/90 hover:to-emerald-400/90 text-black font-[900] text-base py-4 px-6 rounded-xl shadow-lg shadow-mint/20 transition-all font-['Open_Sans',_sans-serif] flex items-center justify-center gap-2" data-id="element-218">
                <ArrowRight size={18} data-id="element-219" />
                QUIERO MI MEGAPACK
              </motion.a>
            </div>
          </FadeIn>

          {/* Card 2: Plus (Highlighted) */}
          <FadeIn delay={0.2} data-id="element-220">
            <motion.div className="relative bg-surface border-2 border-mint rounded-3xl p-8 flex flex-col h-full shadow-2xl" animate={{
            boxShadow: ['0 0 20px rgba(152,224,186,0.08)', '0 0 40px rgba(152,224,186,0.15)', '0 0 20px rgba(152,224,186,0.08)']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-221">
              {/* Trophy + Badge */}
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 flex items-center gap-2 bg-mint text-black font-bold px-5 py-2 rounded-full text-sm shadow-lg shadow-mint/30" data-id="element-222">
                <Trophy size={16} fill="currentColor" data-id="element-223" />
                La más elegida
              </div>

              <div className="mb-4 mt-4" data-id="element-224">
                <h3 className="text-mint text-xl font-[900] font-['Open_Sans',_sans-serif] uppercase mb-2" data-id="element-225">
                  🚀 Megapack + Nutripro Plus
                </h3>
                <p className="text-white/50 text-sm font-medium leading-relaxed" data-id="element-226">
                  6 Tomos + 6 Bonos + NUTRIPRO PLUS 🚀 + Sistema de Evaluación
                  Antropométrica PRO
                </p>
              </div>

              <div className="mb-6 flex-1" data-id="element-227">
                <p className="text-white/40 line-through text-base mb-1" data-id="element-228">
                  Antes: $43.990 ARS
                </p>
                <p className="text-4xl md:text-5xl font-[900] text-mint font-['Open_Sans',_sans-serif]" data-id="element-229">
                  $27.990
                  <span className="text-base text-white/40 font-normal ml-2" data-id="element-230">
                    ARS
                  </span>
                </p>
              </div>

              <motion.a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNAwU2fxxoZKry1E28dbN7i/es-ar?_r=AQABUz-DDfQSB1cPsEXTz0QcvPazglRT5B40d_lxn2LWtqI&cart_link_id=psdRzX2L&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-gradient-to-r from-mint to-emerald-400 hover:from-mint/90 hover:to-emerald-400/90 text-black font-[900] text-base py-4 px-6 rounded-xl shadow-lg shadow-mint/20 transition-all font-['Open_Sans',_sans-serif] flex items-center justify-center gap-2" data-id="element-231">
                🚀QUIERO NUTRIPRO PLUS
              </motion.a>
            </motion.div>
          </FadeIn>
        </div>
      </div>
    </section>;
}